import {
    ChangeDetectionStrategy,
    ChangeDetectorRef,
    Component,
    EventEmitter,
    Input,
    OnInit,
    Output,
} from '@angular/core';
import { FileMetaData } from '@modeso/types__aumico-lib-companies-be';

@Component({
    selector: 'upload-modal',
    templateUrl: './upload-modal.component.html',
    styleUrls: ['./upload-modal.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UploadModalComponent implements OnInit {
    @Input() acceptedExtensions: string;
    @Input() fileMetaData: Partial<FileMetaData>;
    @Input() file: File;
    @Output() fileUploaded = new EventEmitter<File>();
    @Output() fileError = new EventEmitter<boolean>();

    uploadedLogo: string | ArrayBuffer;
    Math = Math;
    fileSizeError = false;
    constructor(private cdr: ChangeDetectorRef) {}

    ngOnInit(): void {
        if (this.file) {
            this.readFile(this.file);
        }
    }

    public onFileUploaded(file: File) {
        this.readFile(file);
        this.setFileMetaData(file);
        this.fileUploaded.emit(file);
    }

    public onFileSizeError(error: boolean) {
        this.fileSizeError = error;
        this.fileError.emit(error);
    }
    onRemoveLogo() {
        this.uploadedLogo = null;
        this.fileMetaData = null;
        this.fileUploaded.emit(null);
    }

    public readFile(file: File): void {
        if (!file) {
            return;
        }
        const reader = new FileReader();
        reader.onload = (e: ProgressEvent<FileReader>) => {
            this.uploadedLogo = e.target?.result;
            this.cdr.markForCheck();
        };
        reader.readAsDataURL(file);
    }

    private setFileMetaData(file: File) {
        this.fileMetaData = {
            size: file.size,
            name: file.name,
        };
    }
}
